import axios from "../axiosInstance"

export type StepStatus = "pending" | "running" | "done" | "error"

export interface StepProgress {
  name: string
  label: string
  phase: number
  status: StepStatus
}

export interface SyncProgressData {
  completedCount: number
  totalCount: number
  currentLabel: string | null
  steps: StepProgress[]
}

export interface SyncStatusResponse {
  isSyncing: boolean
  lastSync: Record<string, string>
  progress: SyncProgressData
  lastResult?: {
    totalUpserted: number
    totalSkipped: number
    totalErrors: number
  }
}

/** POST /sync/all — Starts a sync. Returns 202 immediately; poll /sync/status for progress. */
export const triggerSyncAll = async (): Promise<void> => {
  try {
    await axios.post("/sync/all")
  } catch (error: any) {
    if (error.response?.status === 409) {
      throw new Error("A sync is already in progress")
    }
    throw error
  }
}

/** GET /sync/status — Current sync progress and last sync timestamps. */
export const getSyncStatus = async (): Promise<SyncStatusResponse> => {
  const res = await axios.get("/sync/status")
  return res.data
}
